import {
    IonBackButton,
    IonButtons,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonLabel,
    IonPage,
    IonRow,
    IonSegment,
    IonSegmentButton,
    IonText,
    IonToolbar,
    isPlatform
} from "@ionic/react"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Profile } from "../../@types/profile";
import { User } from "../../@types/user";
import { RootState } from "../../store/rootReducer";
import { setInitialData, setProfile, setUser } from "../../store/userProfileOrganization";
import { findOrganizations } from "../../store/userProfileOrganization/actions/findOrganizations";
import { findProfileOrganization } from "../../store/userProfileOrganization/actions/findProfileOrganizations";
import { selectOrganizationSelectedCounter } from "../../store/userProfileOrganization/selectors/selectOrganizationSelectedCounter";
import { AssignOrganizationStatus } from "./components/AssignOrganizationStatus";
import { ConfirmButton } from "./components/ConfirmButton";
import { OrganizationSelected } from "./components/OrganizationSelected";
import { OrganizationSelector } from "./components/OrganizationsSelector";

export const UserProfileOrganization = () => {
    const [selectorActive, setSelectorActive] = useState<boolean>(true);
    const dispatch = useDispatch();
    const { id }: { id: string } = useParams();
    const profile: Profile = useSelector((state: RootState) => state.profileDetail.profile);
    const usersList: User[] = useSelector((state: RootState) => state.profileDetail.userList);
    const user = usersList.filter((infoUser) => infoUser.id == id)[0];
    const counter = useSelector(selectOrganizationSelectedCounter);

    useEffect(() => {
        dispatch(setInitialData());
        dispatch(findOrganizations());
        dispatch(findProfileOrganization({ userId: id, profileId: profile.id }));
        dispatch(setUser(user));
        dispatch(setProfile(profile));

    }, [dispatch, user, profile])

    return (
        <IonPage>
            <IonHeader class="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton
                            text={isPlatform("ios") ? "Usuarios" : ""}
                            defaultHref={`/app/tic/perfiles/detalle/${profile.id}`}
                            color="light"
                        />
                    </IonButtons>
                    <IonButtons slot="end">
                        <ConfirmButton />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <section
                    className={"ion-margin"}
                >
                    <IonText color="primary">
                        <h2>{profile ? `Perfil ${profile.name}` : "Perfil"}</h2>
                    </IonText>
                    <IonText color="primary">
                        {user ? <h3>{user.name}</h3> : <h3></h3>}
                    </IonText>
                    <IonGrid class="ion-no-margin ion-no-padding">
                        {/* Inicio - Para móviles */}
                        <IonRow className="ion-hide-md-up">
                            <IonSegment
                                value={selectorActive ? "disponibles" : "seleccionados"}
                                color="secondary"
                                style={{ maxWidth: '100%', position: 'fixed', bottom: 0, left: 0, backgroundColor: 'white', zIndex: 1000 }}
                            >
                                <IonSegmentButton value="disponibles" onClick={() => { setSelectorActive(true) }}>
                                    <IonLabel>Disponibles</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton value="seleccionados" onClick={() => { setSelectorActive(false) }}>
                                    <IonLabel>Seleccionados ({counter})</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                            <IonCol style={{ paddingLeft: 0, paddingRight: 6 }}>
                                {selectorActive ? (
                                    <OrganizationSelector />
                                ) : (
                                    <OrganizationSelected />
                                )}
                            </IonCol>
                            <IonFooter style={{ height: '2rem' }} className="ion-no-border">
                            </IonFooter>
                        </IonRow>
                        {/* Fin - Para móviles */}
                        {/* Inicio - para desktop */}
                        <IonRow className="ion-hide-md-down">
                            <IonGrid class="ion-no-margin ion-no-padding">
                                <IonRow>
                                    <IonCol size="6" style={{ paddingLeft: 0, paddingRight: 6 }}>
                                        <OrganizationSelector />
                                    </IonCol>
                                    <IonCol size="6" style={{ paddingRight: 0, paddingLeft: 6 }}>
                                        <OrganizationSelected />
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonRow>
                        {/* Fin - Para desktop */}
                    </IonGrid>
                </section>
                <AssignOrganizationStatus />
            </IonContent>
        </IonPage>
    )
}